import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'gob-range',
  templateUrl: './range.component.html',
  styleUrls: ['./range.component2.css']
})
export class RangeComponent implements OnInit {
  @Output() readonly setVal: EventEmitter<any>=new EventEmitter<any>();
  @Input() min: number=0;                  
  @Input() max: number=999;                
  @Input() minVal: number; // Laissé indéfini pour l'initialisation auto
  @Input() maxVal: number; // Laissé indéfini pour l'initialisation auto
  @Input() steps: number=5;                
  @Input() symbol: string;                 
  @Input() height: number=5;               
  @Input() background: string='#87b612';   
  @Input() color: string='#000';           
  @Input() title: boolean=false;           

  // Écart minimum obligatoire entre les deux curseurs
  private readonly minGap: number = 1;

  constructor() { }

  ngOnInit(): void { 
    // PAR DÉFAUT : On place les jauges aux extrémités
    if (this.minVal === undefined) { this.minVal = this.min; }
    if (this.maxVal === undefined) { this.maxVal = this.max; }

    // Correction de sécurité si les valeurs sont trop proches ou inversées
    if(this.maxVal - this.minVal < this.minGap) {
      this.maxVal = Math.min(this.max, this.minVal + this.minGap);
      this.minVal = Math.max(this.min, this.maxVal - this.minGap);
    }
  }

  /**
   * Gestion du curseur MIN (Gauche)
   */
  changeMin() {
    const limit = this.maxVal - this.minGap;
    if (this.minVal > limit) {
      this.minVal = limit; // Bloque le passage au-dessus du Max
    }
    this.emitValues();
  }

  /**
   * Gestion du curseur MAX (Droite)
   */
  changeMax() {
    const limit = this.minVal + this.minGap;
    if (this.maxVal < limit) {
      this.maxVal = limit; // Bloque le passage en-dessous du Min
    }
    this.emitValues();
  }

  private emitValues() {
    this.setVal.emit({min: this.minVal, max: this.maxVal});
  }

  getLabel(){
    let sufix: string=((!this.title)? this.symbol : '');
    let result: string=''+this.min+sufix;
    let step: number=Math.floor(this.max/this.steps);
    for(let i: number=1; i*step<this.max; i++){
      result+=' '+i*step+sufix;
    }
    result+=' '+this.max+sufix;
    return result;
  }
}